import React, { FC, useEffect, useState } from 'react'
import TasksTable from '../tasks/_TasksTable'
import { Dropdown, MenuProps } from 'antd'
import { TreatmentFilterModel, TreatmentType } from '../models/superbit-api-models'
import _, { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { setCreateTreatmentFrom, setPopUpTreatmentModel, setPopUpTreatmentSuesModel, setReloadSuesTreatments, setTask, setTreatmentId } from '../app-context/tasksSlice';
import { RootState } from '../app-context/store';
import { useNavigate } from 'react-router-dom';
import ConfirmPopUp from '../tasks/_ConfirmPopup';
import { TaskDocumentPopup } from '../tasks/_TaskDocumentPopup';
import { setSueInsuranceCompanyId } from '../app-context/suesSlice';

interface TreatmentsSueProps {
    sueData: any;
    sueTreatmentsList: any[];
    config: any;
    showAddTreatmentPopup?: (type: number) => void;
    customerId?: string;
}

const TreatmentsSue: FC<TreatmentsSueProps> = ({ sueData, sueTreatmentsList, config, showAddTreatmentPopup, customerId }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const customerCardModel = new CustomerCardModel();


    const [treatmentsList, setTreatmentsList] = useState<any[]>(sueTreatmentsList);
    const [loading, setLoading] = useState<boolean>(false);
    const [assignmentIdForDelete, setAssignmentIdForDelete] = useState<string | null>(null)
    const [showDeleteAssignmentPopUp, setShowDeleteAssignmentPopUp] = useState<boolean>(false);
    const [documentUrl, setDocumentUrl] = useState<any[]>([]);
    
    // const [treatmentsFilter, setTreatmentsFilter] = useState<any>({
    //     sueId: sueData.id,
    //     page: 1,
    // })
    const reloadSuesTreatments = useSelector((state: RootState) => state.tasks.reloadSuesTreatments);


    const getTreatments = async (filter?: TreatmentFilterModel) => {
        setLoading(true);
        setTreatmentsList([]);
        console.log('sueId: sueData.id', sueData)

        const treatmentsData = await customerCardModel.treatmentsFilter({
            page: 1,
            sueId: sueData.id
        } as TreatmentFilterModel);
        const treatments: any[] = [];
        if (treatmentsData.items && treatmentsData.items.length > 0) {
            treatmentsData.items.forEach((item: any) => {
                if (item.treatmentActivities && item.treatmentActivities.length > 0) {
                    const lastActivity = item.treatmentActivities[item.treatmentActivities.length - 1];
                    if (lastActivity && lastActivity.createdById !== '') {
                        item.updatedBy = lastActivity.createdBy;
                        item.updatedById = lastActivity.createdById;
                    }
                }
                treatments.push(item);
            })
        }

        const treatmentsSorted = treatments.sort((a: any, b: any) => {
            const dateA = new Date(a.createdDate);
            const dateB = new Date(b.createdDate);
            // Sort by eventDate in descending order
            return dateB.getTime() > dateA.getTime() ? 1 : -1;
        });


        setTreatmentsList(treatmentsSorted);
        setLoading(false);
    }
    useEffect(() => {
        if (!sueData || !sueData.id) {
            return;
        }

        getTreatments();
    }, [sueData.id]);

    useEffect(() => {
        if (reloadSuesTreatments) {
            getTreatments();
            dispatch(setReloadSuesTreatments(false));
        }
    }, [reloadSuesTreatments]);

    const onAddOfferOptionClick = (type: number) => {
        console.log('onAddOfferOptionClick-showAddTreatmentPopup', 111)
        if (config.showAddTreatmentPopup) {
            console.log('onAddOfferOptionClick-showAddTreatmentPopup-inside', 111)
            config.showAddTreatmentPopup(type, sueData.customerId ? sueData.customerId : customerId ? customerId : '');
        }
        dispatch(setCreateTreatmentFrom({ type: 'sue', id: sueData.id }));
        dispatch(setSueInsuranceCompanyId(sueData.insuranceCompanyId));

        // if(showAddTreatmentPopup) {
        //     console.log('onAddOfferOptionClick-showAddTreatmentPopup-2-inside', 222)
        //     showAddTreatmentPopup(type);
        // }
    }

    const editTask = async (id?: string) => {
        if (!id) {
            let newTreatment =
            {
                "id": null,
                "createdDate": null,
                "eventDate": null,
                "alertDate": null,
                "treatmentType": 0,
                "topic": "",
                "note": "2",
                "filePath": null,
                "customerId": null,
                "customer": null,
                "from": "",
                "to": "",
                "cc": "",
                "bcc": "",
                "assignmentStatus": null,
                "policyRelatedId": null,
                "policyRelated": null,
                "sueRelatedId": null,
                "sueRelated": null,
                "leadRelatedId": null,
                "leadRelated": null,
                "relationEntitiesModel": null,
                "agentId": null,
                "agent": null,
                "userId": null,
                "user": null,
                "startDate": null,
                "endDate": null,
                "fileAttachment": null,
                "customersIds": null,
                "leadsIds": null,
                "companyId": null,
                "company": null,
                "priority": null,
                "treatmentOutcome": null,
                "emailDeliveryType": null,
                "address": null,
                "smsFrom": null,
                "smsTo": null,
                "smsMessage": null,
                "smsPhone": null,
                "smsSenderId": null,
                "faxPhone": null,
                "sentByFax": null,
                "faxBy": null,
                "faxInHonorOf": null,
                "statusChangeEmail": null,
                "statusChangeSms": null,
                "location": null,
                "includeLogo": false,
                "emailBody": "",
                // "emailBody": "KYUSHU PLUS 4X2 (1987) היברידי רגיל פנאי-שטח;;;<p><span style=\"font-size:16px\"><strong><u>ביטוח מסוג מקיף כולל כיסוי תאונה וגניבה </u></strong></span></p>\r\n\r\n<p><span style=\"font-size:16px\"><u>הביטוח כולל:</u></span></p>\r\n\r\n<ul dir=\"rtl\">\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData3</span></span></li>\r\n\t<li><span style=\"font-size:16px\">התחייבות לתיקון בחלפים מקוריים במוסך מורשה לקסוס.</span></li>\r\n\t<li><span style=\"font-size:16px\">גרירה ושרותי דרך 24 שעות ביממה- ממסי בטלפון 5202*. (כולל החלפת גלגל, גרירה מכביש 6 ומחניונים)</span></li>\r\n\t<li><span style=\"font-size:16px\">החזר הוצאות נסיעה ממקום התאונה עד 250 שח , במידה והרכב אינו במצב נסיעה.</span></li>\r\n\t<li><span style=\"font-size:16px\">כיסוי שבר שמשות סטנדרטי (לא מקורי) ללא השתתפות עצמית</span></li>\r\n\t<li><span style=\"font-size:16px\">רכב חליפי לקסוס* : לנהגים מגיל 24 מעל שנה ותק נהיגה :&nbsp;בתאונה - רכב חליפי במוסך הסדר לקסוס &nbsp;מפתח תמורת מפתח.&nbsp;בגניבה או טוטאלוסט -30 יום או עד קבלת תשלום מחברת הביטוח (המוקדם מביניהם)</span></li>\r\n\t<li><span style=\"font-size:16px\">גבול אחריות לפגיעה בצד ג&#39; 1,500,000 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">כינון אוטומט במוסך הסדר - ללא תוספת פרמיה.</span></li>\r\n\t<li><span style=\"font-size:16px\">הרכב יחשב לאובדן כללי בנזק מעל 50% בלבד.</span></li>\r\n\t<li><span style=\"font-size:16px\">השתתפות עצמית במוסכי הסדר לקסוס :&nbsp;לרכב בשווי עד 350000 שח &nbsp;1390 ₪ , לנהגים עד גיל 21 &nbsp;)לא חדשים) 2092 ש&quot;ח, לנהגים מגיל 17 או לנהגים חדשים 2794 ₪ &#39;&nbsp;&nbsp;לרכב בשווי מעל 350000 שח : 2000 ₪ , &nbsp; &nbsp; לנהגים 17+ או נהגים חדשים 3000 ₪ .</span></li>\r\n\t<li dir=\"RTL\" style=\"text-align:right\"><span style=\"font-size:16px\"><span style=\"font-family:&quot;Times New Roman&quot;,&quot;serif&quot;\"><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">השתתפות עצמית בירידת ערך 1.5%</span><span dir=\"LTR\" style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">.</span><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\"> ברכבים בשווי מעל 350000 שח- השתתפות עצמית בירידת ערך 5%.</span></span></span></li>\r\n\t<li><span style=\"font-size:16px\">הגנה משפטית עד 50,000 ₪. ה&quot;ע 200 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">ביטוח תוספות ואבזור ברכב עד 10,000 ₪ ללא תוספת פרמיה בכפוף להצגת חשבונית בגין האביזרים טרם עריכת הביטוח .</span></li>\r\n\t<li><span style=\"font-size:16px\">שירות VIP ללקוחות הקולקטיב 24 שעות ביממה בטלפון 8099*.</span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData1</span></span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData2</span></span></li>\r\n</ul>\r\n\r\n<p dir=\"RTL\"><span style=\"font-size:16px\">*רכב חליפי לקסוס או לחילופין רכב מנהלים&nbsp;על בסיס&nbsp;&nbsp;זמינות המשכיר.</span></p>\r\n\r\n<p>&nbsp;</p>\r\n;;;<p dir=\"RTL\"><span style=\"font-size:14px\"><strong><u>הביטוח מותנה וכפוף</u></strong><strong><u>:</u></strong></span></p>\r\n\r\n<ul>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">באישור העדר תביעות ביטוח מקיף 3 שנים אחרונות &ndash; יש להציג אישור תוך 7 ימים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">אישור בדיקת מיגון הנדרש ע&quot;י חברת הביטוח.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">כל הכיסויים בכפוף לתנאי הפוליסה ולכתבי השירות הרלוונטיים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">את הביטוח מקיף ניתן לחלק ב-4 תש&#39; ללא ריבית וחובה ב-12 תש&#39; ללא ריבית.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">חלק מהכיסויים נמכרים ללא מעורבות חב&#39; הביטוח והנם באחריות מלאה של נותני השירות .</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">ט.ל.ח</span></li>\r\n</ul>\r\n",
                "includeCustomerInfo": false,
                "isFullDay": false,
                "forTreatmentById": null,
                "forTreatmentBy": null,
                "belongsToId": null,
                "belongsTo": null,
                "employer": null,
                "employerId": null,
                "riderId": null,
                "rider": null,
                "status": null,
                "assignmentStatusType": 0,
                "whatsAppMessageId": null,
                "treatmentActivities": [],
                "treatmentTypeIcon": "fa-mobile-alt",
                "upsertActionName": "UpsertSmsTreatment",
                "FileAttachments": [],
                "seen": false
            }
            console.log('newTreatment', newTreatment);
            dispatch(setTask(newTreatment));
        } else {
            const data = await customerCardModel.getAssignment(id);
            await customerCardModel.setAssignmentSeen(id);

            // set data to redux store for use in the popup
            console.log('data', data);
            dispatch(setTask(data));
            dispatch(setPopUpTreatmentSuesModel({ show: true, type: 1 }));

            // to know from where we open edit treatment of task
            dispatch(setCreateTreatmentFrom({ type: 'sue', id: sueData.id }));
            // setSelectedAssigment(data);
        }
        // setShowAddTreatmentPopup(true)
    }

    const emptyFunc = () => { }

    const editEmail = async (id: string) => {
        // await customerCardModel.setAssignmentSeen(id);
        // if (treatmentsList) {
        //     const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
        //     treatmentsList[taskIndex].seen = true;
        //     setTreatmentsList(treatmentsList);
        // }
        // dispatch(setPopUpTreatmentSuesModel({ show: true, type: 3 }));
        // // to know from where we open edit treatment of mail
        // dispatch(setCreateTreatmentFrom({ type: 'policy', id: policyId }));


    }

    const editDoc = async (id: string) => {
        console.log('editDoc', id)
        await customerCardModel.setAssignmentSeen(id);
        if (treatmentsList) {
            const taskIndex = treatmentsList.findIndex((t: any) => t.id == id);
            treatmentsList[taskIndex].seen = true;
            setTreatmentsList(treatmentsList);
        }
        dispatch(setPopUpTreatmentSuesModel({ show: true, type: 4 }));
        dispatch(setTreatmentId(id));
        // to know from where we open edit treatment of doc
        dispatch(setCreateTreatmentFrom({ type: 'sue', id: sueData.id }));

    }

    const setStatus = (id: string, status: string) => {
        customerCardModel.setAssignmentStatus(id, status).then((res: any) => {
            getTreatments();
        })
    }

    const addOfferOptions: MenuProps['items'] = [
        {
            key: '1',
            label:
                <li className="pointer rtl"
                    onClick={() => { onAddOfferOptionClick(TreatmentType._1) }}
                >
                    משימה
                </li>,
        },
        {
            key: '2',
            label:
                <li className="pointer rtl"
                    onClick={() => { onAddOfferOptionClick(TreatmentType._2) }}
                >
                    וואצפ
                </li>,
        },
        // {
        //     key: '3',
        //     label:
        //         <div className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._3) }}
        //         >
        //             תיעוד דוא"ל
        //         </div>,
        // },
        // {
        //     key: '4',
        //     label:
        //         <li className="pointer rtl"
        //             onClick={() => { onAddOfferOptionClick(TreatmentType._4) }}
        //         >
        //             תיעוד
        //         </li>,
        // }

    ];

    const clearTreatmentsSueFliter = () => {
        getTreatments();
    }

    const redirectToClient = (customerId: any) => {

        const tabsForSave: any[] = [];
        const tContent: any = {
            type: "editCustomer",
            title: sueData.customer.fullName,
            id: sueData.customer.id,
            mode: 1,
            editData: undefined,
            loaded: false
        }
        tabsForSave.push(tContent);
        localStorage.setItem('clientsOpenTabs', JSON.stringify(tabsForSave));

        navigate(`/Clients/`);
    }

    const deleteAssigment = (id: string) => {
        // console.log('deleteAssigment');
        // if(props.actions && props.actions.delete) {
        //     props.actions.delete(id);
        // }
        console.log('deleteAssigmentid', id)
        if (id && id != '') {
            setAssignmentIdForDelete(id);
            setShowDeleteAssignmentPopUp(true);
        }
    }

    const onApproveDeleteAssignment = async (id: string) => {
        // setLoading(true)
        await customerCardModel.deleteAssigment(id);
        setAssignmentIdForDelete(null);
        setShowDeleteAssignmentPopUp(false);
        console.log('onApproveDeleteAssignment', id)
        // setLoading(false);
        getTreatments();

        // setPopupMessageContent('המשימה נמחקה בהצלחה');
        // setPopupMessageTitle('מחיקת משימה');
    }

    const hideDeleteAssingmentPopup = () => {
        setShowDeleteAssignmentPopUp(false)
    }

    const onShowDocumentPopUp = (url: any[]) => {
        console.log('onShowDocument-onShowDocumentPopUp', url)
        setDocumentUrl(url);
    }

    const onHideDocumentPopUp = () => {
        setDocumentUrl([]);
    }

    return (
        <>

            {
                documentUrl && documentUrl.length > 0 && (
                    <TaskDocumentPopup
                        ClosePopup={onHideDocumentPopUp}
                        documentUrl={documentUrl}
                    />
                )
            }
            <div className='white-block white-block-fixed-height'>
                <section className=''>
                    <div className='section-sue-title'>
                        טיפול שוטף
                    </div>
                </section>
                <section>
                    <div className="parameter-row">
                        <div className="parameter-item">
                            <div className="filter-button">
                                <div className="icon refresh-counter pointer" onClick={clearTreatmentsSueFliter}></div>
                            </div>
                        </div>

                        <div>
                            {/* <div className="icon add black pointer" onClick={onSueAddTreatment}></div> */}

                            <Dropdown menu={{ items: addOfferOptions }}>
                                <button type="button" className="button blue has-icon flex-centered flex-justify-center">
                                    <div className="icon add">
                                    </div>
                                    Add
                                </button>
                            </Dropdown>
                        </div>
                    </div>
                    <div className="content-table">

                        {loading && <div className="loading-spinner"></div>

                        }

                        {!loading && <TasksTable data={treatmentsList}
                            actions={{
                                edit: (id: string) => editTask(id),
                                editEmail: (id: string) => editEmail(id),
                                editDoc: (id: string) => editDoc(id),
                                sendWhatsApp: (id: string) => emptyFunc(),
                                print: (id: string) => emptyFunc(),
                                setStatus: (id: string, newStatus: string) => setStatus(id, newStatus),
                                delete: (id: string) => deleteAssigment(id),
                                onSortChange: (id: string) => emptyFunc(),
                                onShowDocument: (url: any[]) => onShowDocumentPopUp(url),
                                redirectToClient: (id: string) => redirectToClient(id),
                                updateSeen: (id: string) => emptyFunc(),
                            }}
                            fromSue={true}
                        />
                        }

                        {
                            showDeleteAssignmentPopUp && <ConfirmPopUp
                                data={assignmentIdForDelete}
                                messageTitle={'מחיקת משימה'}
                                message={'האם את/ה בטוח?'}
                                OnApprove={onApproveDeleteAssignment}
                                ClosePopup={hideDeleteAssingmentPopup}
                                fromLeadTreatments={true} />
                        }
                    </div>

                </section>
            </div>
        </>
    )
}

export default TreatmentsSue;